import React from 'react';
import { Wallet, TrendingDown, BrainCircuit, Home } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <Wallet className="w-8 h-8 text-[#d4a843]" data-id="element-106" />,
    text: 'Querés generar ingresos extra pero no sabés por dónde empezar ni qué vender.'
  }, {
    icon: <TrendingDown className="w-8 h-8 text-[#d4a843]" data-id="element-107" />,
    text: 'Probaste otros negocios que no funcionaron o requerían demasiada inversión inicial.'
  }, {
    icon: <BrainCircuit className="w-8 h-8 text-[#d4a843]" data-id="element-108" />,
    text: 'Te sentís abrumada por emprendimientos complejos que requieren conocimientos técnicos.'
  }, {
    icon: <Home className="w-8 h-8 text-[#d4a843]" data-id="element-109" />,
    text: 'Buscás algo que puedas hacer desde tu casa, manejando tus propios tiempos.'
  }];
  return <section className="py-20 bg-[#0d0906] relative" data-id="element-110">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-111">
        <div className="text-center mb-16" data-id="element-112">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-113">
            ¿Te identificás con <span className="text-[#d4a843]" data-id="element-114">esto?</span>
          </h2>
          <p className="text-lg text-[#c9b99a] max-w-2xl mx-auto" data-id="element-115">
            Sabemos lo frustrante que puede ser querer salir adelante y no
            encontrar el camino correcto. No estás sola.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-116">
          {problems.map((problem, index) => <div key={index} className="glass-card p-8 flex items-start gap-6 hover:bg-white/10 transition-colors" data-id="element-117">
              <div className="p-4 bg-[#d4a843]/10 rounded-xl shrink-0" data-id="element-118">
                {problem.icon}
              </div>
              <p className="text-lg text-[#c9b99a] leading-relaxed" data-id="element-119">
                {problem.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}